import { addTask } from 'domain-task'
import { getModules } from '../initial/selectors'
import { getTracking } from './selectors'
import { getCookie } from '../../../../utils/helpers/getCookie'
import { getEstateTypeByTypeBien } from '../../../../utils/helpers/getEstateTypeByTypeBien'

const PROJECT_NAME = 'SeLogerPagePlan'
const BASE = '/tracking/'
const SET_ENV = `${PROJECT_NAME}${BASE}set-env`
const SET_PUSH = `${PROJECT_NAME}${BASE}set-push`
const SET_META = `${PROJECT_NAME}${BASE}set-meta`
const SET_TYPE = `${PROJECT_NAME}${BASE}set-type`

export function setEnv({ env }) {
  return {
    type: SET_ENV,
    payload: { env },
  }
}

export function setPush({ push }) {
  return {
    type: SET_PUSH,
    payload: { push },
  }
}

export function setMeta({ meta }) {
  return {
    type: SET_META,
    payload: { meta },
  }
}

export function setType({ type }) {
  return {
    type: SET_TYPE,
    payload: { type },
  }
}

export function trackEnv({ env }) {
  return function(dispatch) {
    const task = Promise.resolve().then(() => {
      dispatch(
        setEnv({
          env,
        }),
      )
    })

    addTask(task)
  }
}

export function trackView({ referrer, location }) {
  return function(dispatch) {
    const type = 'view'

    const meta = {
      site: 'SL',
      pagename: 'Page_plans-immobilier',
      language: 'fr',
      url_path: location.hostname + location.pathname,
      referrer,
    }

    const task = Promise.resolve().then(() => {
      dispatch(setMeta({ meta }))
      dispatch(setType({ type }))
      dispatch(
        setPush({
          push: {
            isRequired: true,
            withDataLayer: false,
          },
        }),
      )
    })

    addTask(task)
  }
}

export function trackPageView({ location, isConnected }) {
  return function(dispatch, getState) {
    const type = 'page_view'
    const { environment } = getTracking(getState())
    const { lastAds } = getModules(getState()).find(module => module.moduleName === 'LastAds') || []

    const clientId = getCookie('_ga').substring(6)

    const avItems = lastAds.map((ad, index) => ({
      city: ad.city,
      currency: 'EUR',
      distribution_type: '2',
      estate_type: getEstateTypeByTypeBien(ad.typeBien),
      id: ad.id.toString(),
      index,
      indoor_surface: ad.surface.toString(),
      list_name: 'seo_page_last_ads_bottom',
      name: 'classified',
      nb_bedrooms: ad.nbChambres.toString(),
      nb_rooms: ad.nbPieces.toString(),
      price: ad.price,
      product_variant: 'classified',
      province: ad.postalCode.substring(0, 2),
      publication_id: 'SL',
      zip_code: ad.postalCode,
    }))

    const avUser = {
      cid: clientId,
      status: isConnected ? 'logged' : 'unlogged',
      uid: typeof window !== 'undefined' || isConnected ? window.localStorage.user_id : '',
    }

    const meta = {
      av_category: 'seo',
      av_environment: environment,
      av_items: avItems,
      av_language: 'fr',
      av_pagetitle: 'seo_page_plans_immobilier_city',
      av_platform: 'web',
      av_site: 'SL',
      av_url_path: location.hostname + location.pathname,
      av_user: avUser,
    }

    const task = Promise.resolve().then(() => {
      dispatch(setMeta({ meta }))
      dispatch(setType({ type }))
      dispatch(
        setPush({
          push: {
            isRequired: true,
            withDataLayer: false,
          },
        }),
      )
    })

    addTask(task)
  }
}

export default function reducer(state = { push: { isRequired: false, withDataLayer: false } }, action = {}) {
  switch (action.type) {
    case SET_ENV:
      return {
        ...state,
        environment: action.payload.env,
      }
    case SET_PUSH:
      return {
        ...state,
        push: action.payload.push,
      }
    case SET_META:
      return {
        ...state,
        meta: action.payload.meta,
      }
    case SET_TYPE:
      return {
        ...state,
        type: action.payload.type,
      }
    default:
      return state
  }
}
